import { observer } from "mobx-react-lite";
import React from "react";
import classnames from "classnames";

export interface SectionProps {
  title: string;
  context?: any;
  children?: React.ReactNode;
  headerInfo?: React.ReactNode;
  buttons?: React.ReactNode;
  contentTable?: boolean;
  className?: string;
}

const Section = observer((props: SectionProps) => {
  const { children, context, title, headerInfo, buttons, contentTable, className } = props;

  const containerClassNames = classnames("rounded", context ? "bg-light" : "bg-danger-light", className);
  const headerClassNames = classnames("rounded-top", "col-12", {
    "bg-danger text-light": !context,
    "bg-secondary text-light": context,
  });
  const contentClassNames = classnames({ "p-4": !contentTable });

  return (
    <div className={containerClassNames}>
      <div className={headerClassNames}>
        <div className="d-flex align-items-center">
          {headerInfo && !context && <div className="align-self-center mr-0 pr-0">{headerInfo}</div>}
          <div className="flex-grow-1">
            <h6 className="my-3 mx-2">{title}</h6>
          </div>
          {buttons}
        </div>
      </div>
      <div className={contentClassNames}>{children}</div>
    </div>
  );
});

export default Section;
